
/**
 * Calcula los totales de un paquete sumando sus insumos
 */
export const getTotalesPaquete = (paqueteId, insumos) => {
    const items = insumos.filter(i => i?._paqueteId === paqueteId);
    return items.reduce((acc, curr) => ({
        subtotal: acc.subtotal + (curr.subtotal || 0),
        impuestos: acc.impuestos + (curr.impuestos || 0),
        total: acc.total + (curr.total || 0)
    }), { subtotal: 0, impuestos: 0, total: 0 });
};

/**
 * Reordena el array de insumos cuando se desagrupa un paquete
 * Manda los sueltos al fondo.
 */
export const reordenarAlDesagrupar = (insumos, paqueteId) => {
    const insumosDeOtrosPaquetes = [];
    const insumosSueltos = [];

    insumos.forEach(item => {
        if (item._paqueteId === paqueteId) {
            // Se convierte en suelto
            insumosSueltos.push({ 
                ...item, 
                _paqueteId: null, 
                _nombrePaquete: null,
            });
        } 
        else if (item._paqueteId) {
            insumosDeOtrosPaquetes.push(item);
        } 
        else {
            insumosSueltos.push(item);
        }
    });

    return [...insumosDeOtrosPaquetes, ...insumosSueltos];
};

/**
 * Prepara el array de paquetes para guardar
 */
export const formatearPaquetesParaGuardar = (statePaquetes, formInsumos) => {
    return statePaquetes.map(paq => {
        const itemsDelPaquete = formInsumos
            .map((item, index) => ({ ...item, originalIndex: index })) 
            .filter(item => item._paqueteId === paq.idInterno);

        return {
            paqueteBaseId: paq.paqueteBaseId || null,
            nombre: paq.nombre,
            imprimirDesglose: paq.imprimirDesglose,
            cantidad: paq.cantidad,
            insumos: itemsDelPaquete.map(item => ({
                indice: item.originalIndex,
                insumoId: item.insumoId,
                cantidad: item.cantidad 
            }))
        };
    });
};